var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HdNotifications',{staticClass:"service-worker-notifications",attrs:{"notifications":_vm.notifications},scopedSlots:_vm._u([{key:"default",fn:function({ notification }){return [_c('NotificationItem',{attrs:{"notification":notification}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }